import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Notifications.frontend.types'

@Injectable({ providedIn: 'root' })
export class Notifications_get_auto_email_rule_requests_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { ruleId?: string, transaction_id?: string, current_date?: string }): Promise<{ requests?: { ruleId?: string, entityType?: string, entityId?: number, to?: string, cc?: string, bcc?: string, subject?: string, body?: string, projectId?: number, attachments?: { type?: string, name?: string, options?: any, packageName?: string, reportName?: string, inputs?: any, attachmentId?: number, attachmentName?: string, attachmentExtension?: string }[] }[], messages?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

